import {
  AccordionDetails,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Stack,
  styled,
  TextField,
  Theme,
  Typography,
  useTheme
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { formatInput } from 'src/util/STR';
import { SqChecklistRadio } from './SqChecklistRadio';
import { useAppSelector } from 'src/store/hooks';

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary
}));

const SQChecklist: React.FunctionComponent<any> = ({
  handleSQCheckListSave,
  isChange,
  setIsChange,
  sqChecklistFormData,
  setSqChecklistFormData,
  teamMembers,
  setUpdatedChecklist,
  validationObjsqChecklistFormData,
  setValidationObjsqChecklistFormData,
  updatedChecklist,
  selectedSite,
  studyId,
  checkedInStartDate,
  setIsNavigateToPannel
}) => {
  const dispatch = useDispatch();
  const { qualificationChecklist, saveTxt } = useFieldTranslation();
  const { user } = useUser();
  const selectedRowData: any = useAppSelector(state => state.sqCheckList.selectedRowData);
  const { checkPermission } = usePermissionWrapper();
  const isDisable = checkPermission('update_sq_checklist');
  const [refreshKey, setRefreshKey] = useState(0);
  const [recentData, setRecentData] = useState({ data: {}, mandatoryValidation: {} });

  useEffect(() => {
    setRefreshKey(refreshKey + 1);
  }, [sqChecklistFormData?.id]);

  const handleSplChange = (e: any) => {
    setIsNavigateToPannel(false);
    if (e.target.type === 'radio') {
      const val = e.target.value;
      const formattedVal = typeof val === 'string' ? formatInput(val) : val;
      setSqChecklistFormData({
        ...sqChecklistFormData,
        [e.target.name]: formattedVal,
        site_id: selectedSite,
        study_id: studyId,
        monitoring_visit_id: selectedRowData.id,
        is_published: false
      });
      setUpdatedChecklist({
        ...updatedChecklist,
        [e.target.name]: formattedVal,
        site_id: selectedSite,
        study_id: studyId,
        updated_by: user,
        monitoring_visit_id: selectedRowData.id,
        is_published: false
      });
      if (!isChange && val && e.target.type === 'radio') {
        setIsChange(true);
      }
      if (val != null && val != '') {
        setValidationObjsqChecklistFormData({ ...validationObjsqChecklistFormData, [e.target.name]: false });
      } else {
        setValidationObjsqChecklistFormData({ ...validationObjsqChecklistFormData, [e.target.name]: true });
      }
    }
    setConfirmExitValue(dispatch, true);
  };

  const handleChange = (e: any) => {
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    setRecentData({
      data: {
        [e.target.name]: formattedVal,
        site_id: selectedSite,
        study_id: studyId,
        monitoring_visit_id: selectedRowData.id,
        is_published: false
      },
      mandatoryValidation: {
        ...recentData.mandatoryValidation,
        ...validationObjsqChecklistFormData,
        [e.target.name]: val === null || val === ''
      }
    });
    if (!isChange) {
      setIsChange(true);
    }
  };

  const handleSiteExpTrails = (event: any) => {
    if (event.target.value == 'Y') {
      setSqChecklistFormData({
        ...sqChecklistFormData,
        [event.target.name]: event.target.value,
        site_id: selectedSite,
        study_id: studyId,
        monitoring_visit_id: selectedRowData.id
      });
      setUpdatedChecklist({
        ...updatedChecklist,
        [event.target.name]: event.target.value,
        site_id: selectedSite,
        study_id: studyId,
        updated_by: user,
        monitoring_visit_id: selectedRowData.id
      });
    } else {
      setSqChecklistFormData({
        ...sqChecklistFormData,
        [event.target.name]: event.target.value,
        site_id: selectedSite,
        study_id: studyId,
        site_trials_ongoing: 0,
        site_trials_completed: 0,
        monitoring_visit_id: selectedRowData.id,
        is_published: false
      });
      setUpdatedChecklist({
        ...updatedChecklist,
        [event.target.name]: event.target.value,
        site_id: selectedSite,
        study_id: studyId,
        updated_by: user,
        monitoring_visit_id: selectedRowData.id,
        is_published: false,
        site_trials_ongoing: 0,
        site_trials_completed: 0
      });
    }
    setIsChange(true);

    if (event.target.value != null && event.target.value != '') {
      setValidationObjsqChecklistFormData({ ...validationObjsqChecklistFormData, [event.target.name]: false });
    } else {
      setValidationObjsqChecklistFormData({ ...validationObjsqChecklistFormData, [event.target.name]: true });
    }
    setConfirmExitValue(dispatch, true);
    setIsNavigateToPannel(false);
  };

  //const [teamMembers, setTeamMbers] = useState([]);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    }
  };

  function getStyles(name: string, personName: string[], theme: Theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium
    };
  }

  const theme = useTheme();

  const [sitePersonnelPresent, setSitePersonnelPresent] = React.useState<string[]>(
    sqChecklistFormData && sqChecklistFormData.site_personnel_present === null
      ? []
      : sqChecklistFormData.site_personnel_present.split(',').filter(Boolean)
  );

  const responsibleContractChange = (event: SelectChangeEvent<typeof sitePersonnelPresent>) => {
    const {
      target: { value }
    } = event;
    setSitePersonnelPresent(typeof value === 'string' ? value.split(',') : value);
    setSqChecklistFormData({
      ...sqChecklistFormData,
      [event.target.name]: event.target.value.toString(),
      site_id: selectedSite,
      study_id: studyId,
      monitoring_visit_id: selectedRowData.id,
      is_published: false
    });
    setUpdatedChecklist({
      ...updatedChecklist,
      [event.target.name]: event.target.value.toString(),
      site_id: selectedSite,
      study_id: studyId,
      updated_by: user,
      monitoring_visit_id: selectedRowData.id,
      is_published: false
    });
    setIsChange(true);

    setConfirmExitValue(dispatch, true);
    setIsNavigateToPannel(false);
  };
  useEffect(() => {
    if (recentData.data) {
      setSqChecklistFormData({
        ...sqChecklistFormData,
        ...recentData.data
      });
      setUpdatedChecklist({
        ...updatedChecklist,
        ...recentData.data
      });
      setValidationObjsqChecklistFormData({ ...validationObjsqChecklistFormData, ...recentData.mandatoryValidation });
    }
  }, [recentData.data]);

  const handleSave = () => {
    handleSQCheckListSave({ ...sqChecklistFormData, ...recentData.data });
  };

  return (
    <AccordionDetails className="sq-checklist-tab">
      <Grid container className="checkbox-block">
        <Grid spacing={3} container className="date-block">
          <Grid item md={4}>
            <FormControl>
              <TextField
                name="site_visit_date"
                value={checkedInStartDate ? checkedInStartDate : sqChecklistFormData.site_visit_date || ''}
                label={qualificationChecklist.label1}
                id="standard-basic"
                variant="standard"
                disabled
              />
            </FormControl>
          </Grid>
          <Grid item md={4}>
            <FormControl>
              <InputLabel id="demo-multiple-name-label">Site Personnel Present</InputLabel>
              <Select
                className="site-present-dropdown"
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                value={
                  sitePersonnelPresent.length > 0
                    ? sitePersonnelPresent
                    : sqChecklistFormData && sqChecklistFormData.site_personnel_present === null
                    ? []
                    : sqChecklistFormData.site_personnel_present.split(',').filter(Boolean)
                }
                onChange={responsibleContractChange}
                input={<OutlinedInput label={qualificationChecklist.label2} />}
                MenuProps={menuProps}
                name="site_personnel_present"
                multiple
                disabled={!isDisable || !checkedInStartDate || !checkedInStartDate}
              >
                {teamMembers.map((option: any) => (
                  <MenuItem
                    key={option.site_per_number}
                    value={`${option.site_per_last_name} ${option.site_per_first_name}`}
                    style={getStyles(
                      `${option.site_per_last_name} ${option.site_per_first_name}`,
                      sitePersonnelPresent,
                      theme
                    )}
                  >
                    {`${option.site_per_last_name} ${option.site_per_first_name}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item md={4}>
            <FormControl>
              <TextField
                name="site_speciality"
                value={sqChecklistFormData.site_speciality}
                onChange={handleSplChange}
                label={qualificationChecklist.label3}
                id="standard-basic"
                variant="standard"
                inputProps={{ maxLength: 50 }}
                disabled={!isDisable || !checkedInStartDate}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Grid md={12} className="input-action">
          <p>
            {qualificationChecklist.label4}? <span style={{ color: 'red' }}>*</span>
          </p>
          <FormControl className="radio-buttons-block" error={validationObjsqChecklistFormData.site_experience_trials}>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="site_experience_trials"
              className="radio-buttons"
              value={sqChecklistFormData.site_experience_trials}
              onChange={handleSiteExpTrails}
            >
              <FormControlLabel
                disabled={!isDisable || !checkedInStartDate}
                value="Y"
                control={<Radio />}
                label="Yes"
              />
              <FormControlLabel disabled={!isDisable || !checkedInStartDate} value="N" control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>
          <FormControl fullWidth margin="normal">
            <Item>
              <TextField
                name="site_trials_completed"
                value={sqChecklistFormData.site_trials_completed}
                label={qualificationChecklist.label5}
                variant="standard"
                disabled={
                  sqChecklistFormData.site_experience_trials == 'Y' && checkedInStartDate && isDisable ? false : true
                }
                onChange={handleSplChange}
                type="number"
                InputProps={{ inputProps: { min: 0, max: 999 } }}
                onInput={(e: any) => {
                  e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                }}
                placeholder="Only numbers allowed."
              />
            </Item>
          </FormControl>
          <FormControl fullWidth margin="normal">
            <Item>
              <TextField
                name="site_trials_ongoing"
                value={sqChecklistFormData.site_trials_ongoing}
                label={qualificationChecklist.label6}
                variant="standard"
                onChange={handleSplChange}
                disabled={
                  sqChecklistFormData.site_experience_trials == 'Y' && checkedInStartDate && isDisable ? false : true
                }
                type="number"
                InputProps={{ inputProps: { min: 0, max: 999 } }}
                onInput={(e: any) => {
                  e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                }}
                placeholder="Only numbers allowed."
              />
            </Item>
          </FormControl>
        </Grid>

        <Grid md={12} className="input-action">
          <p>
            {qualificationChecklist.label7}? <span style={{ color: 'red' }}>*</span>
          </p>
          <FormControl
            className="radio-buttons-block"
            error={validationObjsqChecklistFormData.site_competitive_trials_on}
          >
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="site_competitive_trials_on"
              className="radio-buttons"
              value={sqChecklistFormData.site_competitive_trials_on}
              onChange={handleSplChange}
            >
              <FormControlLabel disabled={!isDisable || !checkedInStartDate} value control={<Radio />} label="Yes" />
              <FormControlLabel
                disabled={!isDisable || !checkedInStartDate}
                value={false}
                control={<Radio />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid md={12} mb={2}>
          <Typography>
            {qualificationChecklist.label8}: <span style={{ color: 'red' }}>*</span>
          </Typography>
          <FormControl fullWidth>
            <Item>
              <TextField
                name="site_positive_attributes"
                key={`site_positive_attributes-${refreshKey}`}
                defaultValue={sqChecklistFormData.site_positive_attributes || ''}
                label="Comment"
                variant="outlined"
                error={validationObjsqChecklistFormData.site_positive_attributes}
                helperText={validationObjsqChecklistFormData.site_positive_attributes && 'Required'}
                onBlur={handleSplChange}
                onChange={handleChange}
                inputProps={{ maxLength: 2000, className: 'Mui-error' }}
                disabled={!isDisable || !checkedInStartDate}
                multiline
                minRows={3}
                maxRows={10}
              />
            </Item>
          </FormControl>
        </Grid>

        <Grid md={12} mb={2}>
          <Typography>
            {qualificationChecklist.label9}: <span style={{ color: 'red' }}>*</span>
          </Typography>
          <FormControl fullWidth>
            <Item>
              <TextField
                name="site_negative_attributes"
                key={`site_negative_attributes-${refreshKey}`}
                defaultValue={sqChecklistFormData.site_negative_attributes || ''}
                label="Comment"
                variant="outlined"
                error={validationObjsqChecklistFormData.site_negative_attributes}
                helperText={validationObjsqChecklistFormData.site_negative_attributes && 'Required'}
                onBlur={handleSplChange}
                onChange={handleChange}
                inputProps={{ maxLength: 2000 }}
                disabled={!isDisable || !checkedInStartDate}
                multiline
                minRows={3}
                maxRows={10}
              />
            </Item>
          </FormControl>
        </Grid>
      </Grid>

      <Grid container className="checklist-radio-actions">
        <Grid md={12}>
          <Grid container>
            <Grid md={8}>
              {qualificationChecklist.label10}? <span style={{ color: 'red' }}>*</span>
            </Grid>
            <Grid md={4}>
              <SqChecklistRadio
                error={validationObjsqChecklistFormData.site_requalification_visit}
                name={'site_requalification_visit'}
                value={sqChecklistFormData.site_requalification_visit}
                handle={handleSplChange}
                isDisable={isDisable}
                checkedInStartDate={checkedInStartDate}
              />
            </Grid>
          </Grid>

          <Grid container>
            <Grid md={8}>
              {qualificationChecklist.label11}. <span style={{ color: 'red' }}>*</span>
            </Grid>
            <Grid md={4}>
              <SqChecklistRadio
                error={validationObjsqChecklistFormData.site_qualification_past_year}
                name={'site_qualification_past_year'}
                value={sqChecklistFormData.site_qualification_past_year}
                handle={handleSplChange}
                isDisable={isDisable}
                checkedInStartDate={checkedInStartDate}
              />
            </Grid>
          </Grid>

          <Grid container>
            <Grid md={8}>
              {qualificationChecklist.label12}? <span style={{ color: 'red' }}>*</span>
            </Grid>
            <Grid md={4}>
              <SqChecklistRadio
                error={validationObjsqChecklistFormData.site_qualification_waived}
                name={'site_qualification_waived'}
                value={sqChecklistFormData.site_qualification_waived}
                handle={handleSplChange}
                isDisable={isDisable}
                checkedInStartDate={checkedInStartDate}
              />
            </Grid>
          </Grid>

          <Grid container>
            <Grid md={8}>
              {qualificationChecklist.label13}. <span style={{ color: 'red' }}>*</span>
            </Grid>
            <Grid md={4}>
              <SqChecklistRadio
                error={validationObjsqChecklistFormData.site_not_suitable}
                name={'site_not_suitable'}
                value={sqChecklistFormData.site_not_suitable}
                handle={handleSplChange}
                isDisable={isDisable}
                checkedInStartDate={checkedInStartDate}
              />
            </Grid>
          </Grid>

          <Grid container>
            <Grid md={8}>
              {qualificationChecklist.label14}. <span style={{ color: 'red' }}>*</span>
            </Grid>
            <Grid md={4}>
              <SqChecklistRadio
                error={validationObjsqChecklistFormData.site_smo_recommended}
                name={'site_smo_recommended'}
                value={sqChecklistFormData.site_smo_recommended}
                handle={handleSplChange}
                isDisable={isDisable}
                checkedInStartDate={checkedInStartDate}
              />
            </Grid>
          </Grid>

          <Grid container>
            <Grid md={8}>
              {qualificationChecklist.label15}? <span style={{ color: 'red' }}>*</span>
            </Grid>
            <Grid md={4}>
              <SqChecklistRadio
                error={validationObjsqChecklistFormData.site_debarred}
                name={'site_debarred'}
                value={sqChecklistFormData.site_debarred}
                handle={handleSplChange}
                isDisable={isDisable}
                checkedInStartDate={checkedInStartDate}
              />
              <FormControl fullWidth margin="normal" className="comment-input">
                <Item>
                  <TextField
                    value={sqChecklistFormData.site_debarred_comment}
                    name="site_debarred_comment"
                    label="Comments"
                    variant="standard"
                    onChange={handleSplChange}
                    inputProps={{ maxLength: 199 }}
                    disabled={!isDisable || !checkedInStartDate}
                  />
                </Item>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container>
            <Grid md={8}>
              {qualificationChecklist.label16}? <span style={{ color: 'red' }}>*</span>
            </Grid>
            <Grid md={4}>
              <SqChecklistRadio
                error={validationObjsqChecklistFormData.site_483}
                name={'site_483'}
                value={sqChecklistFormData.site_483}
                handle={handleSplChange}
                isDisable={isDisable}
                checkedInStartDate={checkedInStartDate}
              />
              <FormControl fullWidth margin="normal" className="comment-input">
                <Item>
                  <TextField
                    value={sqChecklistFormData.site_483_comment}
                    name="site_483_comment"
                    id="standard-disabled"
                    label="Comments"
                    variant="standard"
                    onChange={handleSplChange}
                    inputProps={{ maxLength: 199 }}
                    disabled={!isDisable || !checkedInStartDate}
                  />
                </Item>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container>
            <Grid md={12}>
              <FormControl fullWidth margin="normal">
                <Item>
                  <TextField
                    name="site_qualification_comments"
                    key={sqChecklistFormData.site_qualification_comments}
                    defaultValue={sqChecklistFormData.site_qualification_comments}
                    label="General Comments"
                    variant="standard"
                    onBlur={handleSplChange}
                    onChange={handleChange}
                    inputProps={{ maxLength: 199 }}
                    disabled={!isDisable || !checkedInStartDate}
                  />
                </Item>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item md={12} display="flex" justifyContent="flex-end">
              <Stack spacing={2} direction="row">
                {isDisable ? (
                  <Button
                    disabled={checkedInStartDate ? !isChange : true}
                    onClick={() => {
                      handleSave();
                      setIsNavigateToPannel(true);
                    }}
                    variant="text"
                  >
                    {saveTxt}
                  </Button>
                ) : (
                  ''
                )}
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AccordionDetails>
  );
};

export default SQChecklist;
